<template>
	<div>
	
		<div class="commonBox" id="section01" v-bind:class="{ on : isViewVisual }">
			<img src="@/assets/img/home_section01_bg.svg" class="bg">
					
			<div class="box">
				<div>
					
					<p class="big">
						여러분의 꿈을 개발해드리는 행성,<br>
						<b>일삼사삼사공</b>에 오신걸 환영합니다.
					</p>
					
					<p class="small">
						웹개발 / 웹디자인 / 웹유지보수<br>
						홈페이지제작 / 쇼핑몰제작 / 각종커스텀
					</p>
					
				</div>
			</div>
			
			<div class="scrollDown">
				<div class="chevron"></div>
				<div class="chevron"></div>
				<div class="chevron"></div>
			</div>
		</div>
		
		<div class="commonBox" id="section02">
			<div>
				<div>
				
					<div class="info">
						<p class="title">홈페이지가 왜 필요로 할까요?</p>
						<p class="sub">
							홈페이지의 필요성을 딱히 느끼지 못하시는 분들이 많이 계실겁니다 😅<br>
							하지만 <b>일삼사삼사공과 홈페이지로 꿈을 개발</b>하신다면<br>많은 것을 누리실 수 있습니다 🥰
						</p>
						<p class="check">
							✔️ 요즘 대세인 SNS만으로는 기업의 이미지가 올라가지 않습니다.
						</p>
						<p class="check">
							✔️ SNS 오픈마켓은 젊은 세대들에게 <b>과다한 광고 및 불친절한 공구로 인해 신뢰도</b>가 좋지 않습니다.
						</p>
						<p class="check">
							✔️ 집에서 장보기까지 편리해진 온라인 시대에 오프라인만으로는 <b>타사와의 경쟁력</b>이 떨어집니다.
						</p>
					</div>
					
					<img src="@/assets/img/home_section02_visual.svg">
					
				</div>
			</div>
		</div>
		
		<div class="commonBox" id="section03">
			<div>
				<div>
					
					<div class="info">
						<p class="title">재구매율 100%, 유지보수 보장 🎉</p>
						<p class="sub">
							다양한 경험을 통해 오래된 경력으로 많은 분들과 함께 해왔습니다.<br>
							실제로 <b>일삼사삼사공</b>과 거래한 리뷰를 확인하실 수 있습니다.
						</p>
						
						<ul>
							<li v-for="row in reviewList">
								<div class="user">
									<p class="name">{{ row.buyer_username }}님</p>
									<p class="rate">{{ row.replied_at }} | 작업일 : {{ row.order.days }}</p>
								</div>
								<div class="review">
									<p class="contents" v-html="row.message"></p>
								</div>
							</li>
						</ul>
						
						<router-link to="/review">개발리뷰 더보기<img src="@/assets/img/icon_right.svg"></router-link>
					</div>
					
					<img src="@/assets/img/home_section03_visual.svg" class="visual">
					
				</div>
			</div>
		</div>
		
		<div class="commonBox" id="section04">
			<div>
				<div>
					
					<div class="info">
						<p class="title">언제 어디서든 함께 하겠습니다.</p>
						<p class="sub">
							<b>일삼사삼사공</b>는 여러분의 곁에 함께 있습니다.<br>
							인스타그램과 네이버 블로그를 통해 소통해보세요 💕
						</p>
						
						<a href="https://instagram.com/134340kr" target="_blank">인스타그램<img src="@/assets/img/icon_link.svg"></a>
						<a href="https://blog.naver.com/134340kr" target="_blank">네이버 블로그<img src="@/assets/img/icon_link.svg"></a>
					</div>
					
					<ul>
						<li v-for="row in postList">
							<a :href="row.url" target="_blank">
								<img :src="row.tumb">
								<p class="title">{{ row.title }}</p>
								<p class="sub">{{ row.date }}<span> | </span><br>{{ row.category }}</p>
							</a>
						</li>
						<li class="none"><p></p></li>
						<li class="none"><p></p></li>
						<li class="none"><p></p></li>
						<li class="none"><p></p></li>
						<li class="none"><p></p></li>
						<li class="none"><p></p></li>
						<li class="none"><p></p></li>
						<li class="none"><p></p></li>
						<li class="none"><p></p></li>
						<li class="none"><p></p></li>
					</ul>
					
				</div>
			</div>
		</div>
		
		<div class="commonBox" id="section05">
			<div>
				<div>
				
					<div class="info">
						<p class="title">지금 바로 개발을 맡겨보세요!</p>
						<p class="sub">
							<b>일삼사삼사공</b>은 지역 상관없이 고객님을 위해 달려갑니다.<br>
							홈페이지 혹은 크몽을 통해 바로 상담을 받아보세요 🧑🏻‍💻
						</p>
					</div>
					
					<div class="link">
						<router-link to="/contact">개발문의 바로가기<img src="@/assets/img/icon_right.svg" class="default"><img src="@/assets/img/icon_right_hover.svg" class="hover"></router-link>
						<a href="https://kmong.com/@일삼사삼사공" target="_blank">크몽으로 문의하기<img src="@/assets/img/icon_right.svg" class="default"><img src="@/assets/img/icon_right_hover.svg" class="hover"></a>
					</div>
					
					<img src="@/assets/img/home_section05_visual.svg" class="visual">
					
				</div>
			</div>
		</div>
		
	</div>
</template>

<style>
	
	#section01 { height: 600px; overflow: hidden; }
	#section01 > img { position: absolute; width: calc(100% + 300px); left: 50%; transform: translateX(-50%); top: 0; max-width: none; }
	#section01 > .bg { z-index: 1; }
	#section01 > .box { width: 100%; float: left; top: 50%; transform: translateY(-50%); z-index: 2; }
	#section01 p { width: 100%; float: left; color: #FFF; text-align: center; transition: all 0.5s; opacity: 0; top: 20px; }
	#section01 p.big { font-size: 32px; font-weight: 400; line-height: 42px; margin-bottom: 20px; transition-delay: 0.03s; }
	#section01 p.small { font-size: 18px; font-weight: 300; line-height: 26px; transition-delay: 0.08s; }
	#section01.on p { opacity: 1; top: 0; }
	#section01 > .scrollDown { position: absolute; width: 24px; height: 24px; bottom: 60px; left: 50%; transform: translateX(-50%); z-index: 2; }
	#section01 > .scrollDown > .chevron { position: absolute; width: 28px; height: 8px; opacity: 0; transform: scale3d(0.5, 0.5, 0.5); animation: scrollDown 3s ease-out infinite; padding: 0; }
	#section01 > .scrollDown > .chevron:first-child { animation: scrollDown 3s ease-out 1s infinite; }
	#section01 > .scrollDown > .chevron:nth-child(2) { animation: scrollDown 3s ease-out 2s infinite; }
	#section01 > .scrollDown > .chevron:before, #section01 > .scrollDown > .chevron:after { content: " "; position: absolute; top: 0; height: 100%; width: 51%; background: #FFF; }
	#section01 > .scrollDown > .chevron:before { left: 0; transform: skew(0deg, 30deg); }
	#section01 > .scrollDown > .chevron:after { right: 0; width: 50%; transform: skew(0deg, -30deg); }
	
	#section02 { background-color: #FFF; font-weight: 300; }
	#section02 b { font-weight: 400; }
	#section02 > div > div { padding: 0 20px; }
	#section02 img { width: 600px; float: right; }
	#section02 .info { position: absolute; width: 550px; left: 20px; top: 50%; transform: translateY(-50%); z-index: 2; }
	#section02 .info > p { width: 100%; float: left; }
	#section02 .info > p.title { font-size: 32px; font-weight: 500; margin-bottom: 20px; }
	#section02 .info > p.sub { font-size: 18px; line-height: 26px; margin-bottom: 10px; }
	#section02 .info > p.check { background-color: #FFF; border-radius: 10px; padding: 15px 20px; font-size: 14px; line-height: 18px; margin-top: 10px; box-shadow: 4px 12px 30px 6px rgba(0, 0, 0, 0.09); }
	
	#section03 { background-color: #E2E1F9; font-weight: 300; overflow: hidden; }
	#section03 b { font-weight: 400; }
	#section03 > div > div { padding: 0 20px; padding-top: 30px; }
	#section03 .visual { width: 500px; float: left; margin-top: 30px; bottom: -1px; }
	#section03 .info { position: absolute; width: 550px; right: 20px; top: 50%; transform: translateY(-50%); z-index: 2; }
	#section03 .info > p { width: 100%; float: left; }
	#section03 .info > p.title { font-size: 32px; font-weight: 500; margin-bottom: 20px; }
	#section03 .info > p.sub { font-size: 18px; line-height: 26px; margin-bottom: 10px; }
	#section03 .info > ul { width: 100%; float: left; }
	#section03 .info > ul > li { width: 100%; float: left; background-color: #FFF; border-radius: 10px; padding: 15px 20px; margin-top: 10px; display: none; }
	#section03 .info > ul > li > div { width: 100%; float: left; }
	#section03 .info > ul > li > div > p { width: auto; float: left; }
	#section03 .info > ul > li > .user { font-size: 11px; }
	#section03 .info > ul > li > .user > .name { margin-right: 10px; }
	#section03 .info > ul > li > .user > .rate { letter-spacing: 0; }
	#section03 .info > ul > li > .review { margin-top: 10px; font-size: 12px; font-weight: 400; line-height: 16px; }
	#section03 .info > ul > li:nth-of-type(1) { display: block; }
	#section03 .info > ul > li:nth-of-type(2) { display: block; }
	#section03 .info > ul > li:nth-of-type(3) { display: block; }
	#section03 .info > a { float: right; margin-top: 10px; font-size: 12px; font-weight: 500; color: #000; margin-right: 10px; }
	#section03 .info > a > img { width: 15px; margin-left: 5px; top: -1px; }
	
	#section04 { background-color: #FFF; font-weight: 300; overflow: hidden; }
	#section04 img { backface-visibility: hidden; transform: translateZ(0); image-rendering: -webkit-optimize-contrast; }
	#section04 b { font-weight: 400; }
	#section04 > div > div { padding: 0 20px; }
	#section04 .info { position: absolute; width: 550px; left: 20px; top: 50%; transform: translateY(-50%); z-index: 2; }
	#section04 .info > p { width: 100%; float: left; }
	#section04 .info > p.title { font-size: 32px; font-weight: 500; margin-bottom: 20px; }
	#section04 .info > p.sub { font-size: 18px; line-height: 26px; margin-bottom: 10px; }
	#section04 .info > a { float: left; margin-top: 10px; font-size: 12px; font-weight: 500; color: #000; margin-right: 10px; }
	#section04 .info > a > img { height: 12px; margin-left: 5px; top: -1px; }
	#section04 ul { display: flex; float: left; left: 550px; padding: 100px 0; }
	#section04 ul > li { width: 200px; float: left; margin-right: 10px; opacity: 0.4; }
	#section04 ul > li > a { width: 100%; float: left; }
	#section04 ul > li > a > img { width: 100%; float: left; margin-bottom: 10px; }
	#section04 ul > li > a > p { width: 100%; float: left; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; text-align: left; }
	#section04 ul > li > a > p.title { font-weight: 400; font-size: 14px; color: #000; }
	#section04 ul > li > a > p.sub { font-size: 10px; color: #666; letter-spacing: 0; margin-top: 5px; }
	#section04 ul > li > a > p.sub > br { display: none; }
	#section04 ul > li:nth-of-type(1) { opacity: 1; }
	#section04 ul > li:nth-of-type(2) { opacity: 1; }
	#section04 ul > li:nth-of-type(3) { opacity: 1; }
	#section04 ul > li.none > p { width: 100%; padding-bottom: 100%; float: left; background-color: #DDD; }
	
	#section05 { background-color: #E2F7F0; font-weight: 300; overflow: hidden; }
	#section05 > div > div { padding: 0 20px; padding-top: 30px; }
	#section05 .visual { width: 500px; left: calc(50% + 80px); transform: translateX(-50%); }
	#section05 .info { position: absolute; width: 550px; left: 20px; top: 50%; transform: translateY(-50%); z-index: 2; }
	#section05 .info > p { width: 100%; float: left; }
	#section05 .info > p.title { font-size: 32px; font-weight: 500; margin-bottom: 20px; }
	#section05 .info > p.sub { font-size: 18px; line-height: 26px; }
	#section05 .link { position: absolute; width: 200px; right: 20px; top: 50%; transform: translateY(-50%); z-index: 2; margin-top: -10px; }
	#section05 .link > a { width: 100%; height: 45px; float: left; line-height: 43px; text-align: left; border: 1px solid #000; font-weight: 500; font-size: 13px; opacity: 1 !important; padding: 0 15px; margin-top: 10px; background-color: rgba(0, 0, 0, 0); transition: color 0.5s, background-color 0.5s; }
	#section05 .link > a > img { position: absolute; width: 20px; max-width: 20px; right: 15px; top: 50%; transform: translateY(-50%); transition: opacity 0.5s; }
	#section05 .link > a > .default { opacity: 1; }
	#section05 .link > a > .hover { opacity: 0; }

	@keyframes scrollDown {
		25% { opacity: 1; }
		33% { opacity: 1; transform: translateY(30px); }
		67% { opacity: 1; transform: translateY(40px); }
		100% { opacity: 0; transform: translateY(55px) scale3d(0.5, 0.5, 0.5); }
	}
	
	@media (hover: hover){
		#section03 .info > a:hover { text-decoration: underline; }
		#section04 .info > a:hover { text-decoration: underline; }
		#section04 ul > li > a:hover > p.title { text-decoration: underline; }
		#section05 .link > a:hover { color: #FFF; background-color: #000; }
		#section05 .link > a:hover > .default { opacity: 0; }
		#section05 .link > a:hover > .hover { opacity: 1; }
	}
	
	@media (max-width: 700px){
		#section01 { height: calc(100vh - 200px); }
		#section01 > img { width: auto; max-width: none; height: 100%; left: 50%; transform: translateX(-50%); }
		#section01 p.big { font-size: 21px; line-height: 28px; margin-bottom: 10px; }
		#section01 p.small { font-size: 14px; line-height: 21px; }
		
		#section02 { padding-top: 30px; }
		#section02 img { width: 100%; }
		#section02 .info { position: relative; width: 100%; left: 0; top: 0; transform: none; }
		#section02 .info > p.title { font-size: 21px; line-height: 28px; text-align: center; }
		#section02 .info > p.sub { font-size: 14px; line-height: 21px; text-align: center; }
		#section02 .info > p.check { font-size: 13px; }
		
		#section03 .visual { width: 100%; margin-top: 20px; }
		#section03 .info { position: relative; width: 100%; right: 0; top: 0; transform: none; }
		#section03 .info > p.title { font-size: 21px; line-height: 28px; text-align: center; }
		#section03 .info > p.sub { font-size: 14px; line-height: 21px; text-align: center; }
		
		#section04 { padding: 30px 0 10px 0; }
		#section04 .info { position: relative; width: 100%; left: 0; top: 0; transform: none; text-align: center; }
		#section04 .info > p.title { font-size: 21px; line-height: 28px; text-align: center; }
		#section04 .info > p.sub { font-size: 14px; line-height: 21px; text-align: center; }
		#section04 .info > a { float: none; display: inline-block; }
		#section04 ul { width: calc(100% + 40px); overflow-x: scroll; left: -20px; padding: 0 10px 0 20px; margin-top: 30px; }
		#section04 ul > li { width: 150px; padding-bottom: 20px; opacity: 1; }
		#section04 ul > li > a > p.sub { line-height: 16px; }
		#section04 ul > li > a > p.sub > span { display: none; }
		#section04 ul > li > a > p.sub > br { display: block; }
		#section04 ul > li.none { display: none; }
		
		#section05 .visual { width: 100%; left: 0; transform: none; margin-top: 30px; }
		#section05 .info { position: relative; width: 100%; float: left; left: 0; top: 0; transform: none; }
		#section05 .info > p.title { font-size: 21px; line-height: 28px; text-align: center; }
		#section05 .info > p.sub { font-size: 14px; line-height: 21px; text-align: center; margin-bottom: 10px; }
		#section05 .link { position: relative; width: 100%; float: left; right: 0; top: 0; margin: 0; transform: none; text-align: center; }
		#section05 .link > a { width: 200px; float: none; display: inline-block; text-align: left; }
	}
	
</style>

<script>
	var $;
	
	export default {
		name : "home",
		data : function(){
			return {
				topVisualTitle : "",
				topVisualSub : "",
				isViewVisual : false,
				reviewList : [],
				postList : []
			}
		},
		methods : {
			pageLoad : function(){
				$ = this;
				
				$.$axios.get("//api.134340.kr/naver/134340kr", { headers: $.$axiosHeader }).then(function(res){
					$.postList = res.data.data;

					$.$parent.pageOpen();
					$.$parent.topVisualTitle = $.topVisualTitle;
					$.$parent.topVisualSub = $.topVisualSub;
					
					$.reviewList = [];
					var frmData = new FormData();
					frmData.append("page", 1);

					$.$axios.post("//api.134340.kr/review/list", frmData, { headers: $.$axiosHeader }).then(function(res){
						for(var i = 0; i < res.data.data.length; i++){
							res.data.data[i].message = res.data.data[i].message.replace(/(?:\r\n|\r|\n)/g, "<br />");

							$.reviewList.push(res.data.data[i]);
						}
						
						setTimeout(function(){
							$.isViewVisual = true;
						}, 1000);
					});
				});
			}
		},
		mounted : function(){
		},
		beforeMount : function(){
			this.pageLoad();
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/home.vue